import {
	Box,
	Button,
	FormHelperText,
	makeStyles,
	TextField
} from '@material-ui/core';
import clsx from 'clsx';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from 'src/actions/accountActions';
import * as Yup from 'yup';
import qs from 'query-string';
import { useLocation } from 'react-router';

const useStyles = makeStyles(() => ({
	root: {}
}));

function LoginForm({ className, onSubmitSuccess, ...rest }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [formErrors, setFormErrors] = useState(null);
	const [loginType, setLoginType] = useState();

	const location = useLocation();
	const { mobile } = qs.parse(location.search) || null;

	return (
		<Formik
			initialValues={{
				username:
					process.env.NODE_ENV == 'production'
						? ''
						: 'fabio.spica@grupposistematica.it',
				password: process.env.NODE_ENV == 'production' ? '' : 'admin',
			}}
			validationSchema={Yup.object().shape({
				username: Yup.string().when("multiple", {
						is: false,
						then: Yup.string().email('Deve essere una email valida'),
						otherwise: Yup.string()
					})
					.max(255)
					.required('Campo richiesto'),
				password: Yup.string()
					.max(255)
					.required('La password è richiesta')
			})}
			onSubmit={async (
				values,
				{ setStatus, setSubmitting, setFieldValue }
			) => {
				try {
					await dispatch(login(values.username, values.password, mobile));
					onSubmitSuccess();
					setFormErrors(null);
				} catch (error) {
					let message;

					if (error?.response?.status === 550) {
						setLoginType("userId");
						setFieldValue('username', '');
						message = "Impossibile autenticare l'utente! Per accedere utilizza la username.";
					} else {
						message =
							error?.response?.data?.message ||
							error?.response?.data || 
							error?.toString() ||
							'Qualcosa è andato storto';
					}

					setFormErrors(message);
					setStatus({ success: false });
					setSubmitting(false);
				}
			}}
		>
			{({
				errors,
				handleBlur,
				handleChange,
				handleSubmit,
				isSubmitting,
				touched,
				values,
				isValid
			}) => (
				<form noValidate className={clsx(classes.root, className)} {...rest}>
					{loginType && (
						<TextField
							fullWidth
							label="Tipo di accesso"
							margin="normal"
							value={loginType}
							variant="outlined"
							select
							SelectProps={{
								native: true
							}}
							onChange={(e) => setLoginType(e.target.value)}
						>
							<option value="userId">UserId</option>
							<option value="email">Email</option>
						</TextField>
					)}

					<TextField
						error={Boolean(touched.username && errors.username)}
						fullWidth
						autoFocus
						helperText={touched.username && errors.username}
						label={loginType === 'userId' ? 'Username' : 'Indirizzo email'}
						margin="normal"
						name="username"
						onBlur={handleBlur}
						onChange={handleChange}
						type={loginType === 'userId'? 'text' : 'email'}
						value={values.username}
						variant="outlined"
					/>
					<TextField
						error={Boolean(touched.password && errors.password)}
						fullWidth
						helperText={touched.password && errors.password}
						label="Password"
						margin="normal"
						name="password"
						onBlur={handleBlur}
						onChange={handleChange}
						type="password"
						value={values.password}
						variant="outlined"
					/>
					<Box mt={2}>
						<Button
							color="secondary"
							disabled={isSubmitting || !isValid}
							fullWidth
							type="button"
							onClick={handleSubmit}
							type="submit"
							variant="contained"
						>
							Log In
						</Button>
						{formErrors && (
							<Box mt={3}>
								<FormHelperText error>{formErrors}</FormHelperText>
							</Box>
						)}
					</Box>
				</form>
			)}
		</Formik>
	);
}

LoginForm.propTypes = {
	className: PropTypes.string,
	onSubmitSuccess: PropTypes.func
};

LoginForm.defaultProps = {
	onSubmitSuccess: () => {}
};

export default LoginForm;
